<!-- ================阅读拓展馆-博雅美育视频详情====================-->
<template>
    <div class="bymy-videoinfo-container">
        <home-head />
        <div class="bymy-videoinfo-body">
            <div class="bymy-videoinfo-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="videoinfo-header">
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                    <div class="videoinfo-title" :title="pageTitle">{{ videoInfo.title }}</div>
                    <div class="header-placeholder"></div>
                </div>

                <!-- 主体内容 -->
                <div class="videoinfo-main">
                    <!-- 左侧工具栏 -->
                    <div class="videoinfo-toolbar">
                        <div class="toolbar-item" :class="{ active: hasFile }" @click="handleMaterial">
                            <el-icon class="toolbar-icon"><Document /></el-icon>
                            <span class="toolbar-text">资料</span>
                        </div>
                        <div class="toolbar-item" :class="{ active: isCollect }" @click="handleCollect">
                            <el-icon class="toolbar-icon"><Star /></el-icon>
                            <span class="toolbar-text">收藏</span>
                        </div>
                        <div class="toolbar-item" :class="{ active: isLike }" @click="handleLike">
                            <el-icon class="toolbar-icon"><Pointer /></el-icon>
                            <span class="toolbar-text">点赞</span>
                        </div>
                    </div>

                    <!-- 资料弹框 -->
                    <el-dialog v-model="materialDialogVisible" title="资料列表" width="600px" :close-on-click-modal="false">
                        <div class="file-list" v-if="fileList && fileList.length > 0">
                            <div class="file-item" v-for="(item, index) in fileList" :key="index" @click="handleFileClick(item)">
                                <el-icon class="file-icon"><Document /></el-icon>
                                <span class="file-name" :title="item.fileName || item.name">{{ item.fileName || item.name || '未命名文件' }}</span>
                            </div>
                        </div>
                        <div class="file-empty" v-else>暂无资料</div>
                    </el-dialog>

                    <!-- 右侧视频及评论 -->
                    <div class="videoinfo-content">
                        <div class="video-player-box" id="video-player">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { infoHumVideo } from "@/api/admin/humanityVideo";
import { addOrCancelCollect, judgeIsCollect } from "@/api/admin/collect";
import { addOrCancelLike, judgeIsLike } from "@/api/admin/likes";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "bymyVideoInfo",
    data() {
        return {
            loading: false,
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            videoId: "",
            videoInfo: {},
            fileList: [],
            materialDialogVisible: false,
            isCollect: false,
            isLike: false,
            businessType: undefined,
            collectType: undefined
        }
    },
    computed: {
        hasFile() {
            return this.fileList && this.fileList.length > 0;
        }
    },
    watch: {},
    created() {
        const query = this.$route.query || {};
        if (query.businessType !== undefined) {
            this.businessType = Number(query.businessType);
        }
        if (query.collectType !== undefined) {
            this.collectType = Number(query.collectType);
        }
        if (query.videoId) {
            this.videoId = query.videoId;
            this.queryVideoInfo();
            this.queryCollectLikeStatus();
        }
    },
    mounted() {},
    methods: {
        /* ===============查询视频详情===================== */
        queryVideoInfo() {
            this.loading = true;
            infoHumVideo({ videoId: this.videoId }).then(res => {
                if (res.data.code === 1) {
                    this.videoInfo = res.data.data;
                    this.fileList = this.videoInfo.fileList
                    this.playVideo();
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============查询收藏/点赞状态===================== */
        queryCollectLikeStatus() {
            if (this.businessType !== undefined && this.collectType !== undefined) {
                judgeIsCollect({
                    relationId: this.videoId,
                    collectType: this.collectType,
                    businessType: this.businessType
                }).then(res => {
                    if (res.data.code === 1) {
                        this.isCollect = !!res.data.data;
                    }
                });
            }
            judgeIsLike({ relationId: this.videoId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !!res.data.data;
                }
            });
        },
        /* ===============视频播放===================== */
        playVideo(){
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#video-player',
                vid: this.videoInfo.videoId,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        },
        /* ===============资料===================== */
        handleMaterial() {
            this.materialDialogVisible = true;
        },
        handleFileClick(item) {
            const url = item.fileUrl || item.url || item.filePath || "";
            if (url) {
                window.open(url, "_blank");
            } else {
                this.$message.info("该文件暂无可下载地址");
            }
        },
        /* ===============收藏===================== */
        handleCollect() {
            if (this.businessType === undefined || this.collectType === undefined) {
                this.$message.warning("无法识别收藏类型");
                return;
            }
            addOrCancelCollect({
                relationId: this.videoId,
                collectType: this.collectType,
                businessType: this.businessType
            }).then(res => {
                if (res.data.code === 1) {
                    this.isCollect = !this.isCollect;
                    this.$message.success(this.isCollect ? "收藏成功" : "已取消收藏");
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
            });
        },
        /* ===============点赞===================== */
        handleLike() {
            addOrCancelLike({ relationId: this.videoId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !this.isLike;
                    this.$message.success(this.isLike ? "点赞成功" : "已取消点赞");
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
            });
        },
        /* ===============返回===================== */
        goBack() {
            this.destroyed();
            this.$router.back();
        }
    }
}
</script>

<style scoped>
.bymy-videoinfo-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.bymy-videoinfo-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.bymy-videoinfo-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.videoinfo-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.videoinfo-title {
    flex: 1;
    text-align: center;
    font-size: 22px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

.header-placeholder {
    width: 108px;
    flex-shrink: 0;
}

/* 主体内容 */
.videoinfo-main {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
}

/* 左侧工具栏 */
.videoinfo-toolbar {
    width: 70px;
    flex-shrink: 0;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #ffffff;
}

.toolbar-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4b5563;
}

.toolbar-item:hover {
    color: #b22222;
    background-color: #fef2f2;
}

.toolbar-item.active {
    color: #b22222;
}

.toolbar-icon {
    font-size: 22px;
    margin-bottom: 6px;
}

.toolbar-text {
    font-size: 13px;
    font-family: sans-serif;
}

/* 右侧内容 */
.videoinfo-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
}





.video-player-box {
    width: 100%;
    background-color: #000000;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
}
.video-player {
    width: 100%;
    height: auto;
    max-height: 520px;
    display: block;
    outline: none;
}

.videoinfo-content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.videoinfo-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}
.videoinfo-content::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}
.videoinfo-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* 评论区域 */
.video-comments {
    flex: 1;
    min-height: 0;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
}

.comments-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.comments-empty {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
}

.empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
}

.comments-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 10px;
}

.comment-item {
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
}

.comment-input-box {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    flex-shrink: 0;
}

.comment-input {
    flex: 1;
    height: 38px;
    line-height: 38px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.comment-input:focus {
    border-color: #b22222;
}

.send-btn {
    width: 46px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1e6fdb;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.send-btn:hover {
    background-color: #1a5fc2;
}

/* 资料弹框文件列表 */
.file-list {
    max-height: 400px;
    overflow-y: auto;
}

.file-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    transition: all 0.2s ease;
}

.file-item:hover {
    background-color: #fef2f2;
}

.file-icon {
    font-size: 20px;
    color: #b22222;
    margin-right: 10px;
    flex-shrink: 0;
}

.file-name {
    flex: 1;
    font-size: 14px;
    color: #1f2937;
    font-family: sans-serif;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.file-empty {
    padding: 40px 0;
    text-align: center;
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
}

@media (max-width: 768px) {
    .videoinfo-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .videoinfo-title { width: 100%; text-align: left; padding: 0; }
    .header-placeholder { display: none; }
    .videoinfo-toolbar { width: 56px; }
    .toolbar-icon { font-size: 18px; }
    .toolbar-text { font-size: 12px; }
    .videoinfo-content { padding: 12px; }
}
</style>
